import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import FormPollField from "../atoms/Poll/FormPollField";
import { pollData } from "../../data/pollData";
import { CREATE_POLL } from "../../api/apiPoll";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../atoms/Button";
import { toast } from "react-toastify";
import Heading from "../atoms/Heading";
import { PropagateLoader } from "react-spinners";

const EncuestaTemplate = () => {
	const [loading, setLoading] = useState(false);
	const { token } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		document.title = "Encuesta de satisfacción";
	}, []);

	const initialValues = pollData.reduce((acc, curr) => {
		acc[curr.name] = "";
		return acc;
	}, {});

	const validate = (values) => {
		const errors = {};
		pollData.forEach((q) => {
			if (q.type === "radio" && !values[q.name]) {
				errors[q.name] = "Este campo es obligatorio";
			}
		});
		return errors;
	};

	const handleSubmit = async (values, { resetForm }) => {
		try {
			setLoading(true);
			const encuestaFormateada = pollData.reduce((acc, curr) => {
				acc[curr.id] = values[curr.name];
				return acc;
			}, {});

			await CREATE_POLL({ answers: encuestaFormateada, token });
			toast.success("Enviado exitosamente, gracias");
			resetForm();
			navigate("/dashboard");
		} catch (error) {
			console.error(error);
			toast.error("Error al enviar");
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="min-h-screen w-full p-4 flex flex-col space-y-4 justify-center items-center pt-6">
			<Heading text="Encuesta de satisfacción" color="blue" />
			<Formik
				initialValues={initialValues}
				onSubmit={handleSubmit}
				validate={validate}
			>
				<Form className=" h-full w-full md:max-w-xl flex flex-col items-center justify-center p-6 bg-gray-100 rounded-lg">
					{pollData.map((field) => (
						<FormPollField
							key={field.id}
							name={field.name}
							label={field.label}
							type={field.type}
						/>
					))}

					<div className="flex items-center justify-center">
						<Button
							type="submit"
							text={loading ? <PropagateLoader color="red" /> : "Enviar"}
							disabled={loading}
						/>
					</div>
				</Form>
			</Formik>
		</div>
	);
};

export default EncuestaTemplate;
